import { ruleStatusOption } from './inventoryApproval.types';


export const STATUS_OPTIONS: ruleStatusOption[] = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
];
